import axios from "axios";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { BASE_URL, ACR, HAZARD_VIEW } from "../../constant/urls";

// Handle schematics generation
export const getSchematics = (selectedRows, GENERATE_SCHEMATICS, exch_sau, setSnackMsg, setAlertOpen, setOpenschematics, setLoading, setNodes, setEdges, setSelectedRows, setOpen) => {
  let cableList = [];
  let queryurl = `${BASE_URL}/${ACR}/${GENERATE_SCHEMATICS}?sau=${exch_sau}&cable_ids=`;

  if (selectedRows.length > 0 && selectedRows.length <= 1) {
    selectedRows.forEach((row) => {
      cableList.push(row['RecoveryCable']);
    });
    queryurl = `${queryurl}${cableList.join()}`;
  }
  (selectedRows.length > 1) && (() => {
    setSnackMsg("Please select one cable at a time.");
    setAlertOpen(true);
    setOpenschematics(false);
  })();

  if (selectedRows.length <= 1) {
    setLoading(true);
    axios.get(queryurl)
      .then((res) => {
        if (res.data.status === "Fail" && res.data.Status_code === 200) {
          setAlertOpen(true);
          setSnackMsg('Something went wrong!.Please try again!');
          setOpenschematics(false);
        }
        res.data && (() => {
          const nodesdata = res.data.nodes;
          const edgedata = res.data.edges.map((item) => ({
            from: item.from,
            to: item.to,
            title: `
              <span style={{fontSize:'4px'}}><b>MEASURED_LENGTH</b></span>: ${item.title.measured_length},
              <br><span style={{fontSize:'4px'}}><b>CABLE_SIZE</b></span>: ${item.title.cable_size},
              <br><span style={{fontSize:'4px'}}><b>CABLE_WEIGHT</b></span>: ${item.title.cable_weigth},
              <br><span style={{fontSize:'4px'}}><b>WORKING</b></span>: ${item.title.working},
              <br><span style={{fontSize:'4px'}}><b>FAULTY</b></span>: ${item.title.faulty},
              <br><span style={{fontSize:'4px'}}><b>SPARES</b></span>: ${item.title.spares},
              <br><span style={{fontSize:'4px'}}><b>OTHERS</b></span>: ${item.title.others},`
          }));
          setNodes(nodesdata);
          setEdges(edgedata);
          setLoading(false);
          setSelectedRows([]);
        })();
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
        setOpen(false);
        setAlertOpen(true);
        setOpenschematics(false);
        setSnackMsg('Something went wrong!.Please try again!');
      });
  }
};

// Handle warnings
export const handleWarnings = (recovery_cables, exch_sau, setHazardData, params, setHazardCount, setLoading, setWarningOpen, setSnackMsg, setAlertOpen) => {
  axios.get(`${BASE_URL}/${ACR}/${HAZARD_VIEW}?SAU=${exch_sau}&Owner_Id1=${recovery_cables}`, { params: params })
    .then((res) => {
      setHazardData(res.data.Data.hazard_data_list);
      setHazardCount(res.data.Data.hazard_count);
      setLoading(false);
      setWarningOpen(true);
    })
    .catch((error) => {
      console.error(error);
      setSnackMsg('Something went wrong!.Please try again!');
      setAlertOpen(true);
    });
};

// Download schematics PDF
export const handleDownloadPDF = (componentRef) => {
  html2canvas(componentRef.current).then(canvas => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF();
    const imgWidth = 170;
    const imgHeight = 290;
    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
    pdf.save('Network_graph.pdf');
  });
};